import React from 'react';
import { Modal, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import ImportUploader from './ImportUploader';
import ImportNotice from './ImportNotice';
import TeacherImportResultTable from './TeacherImportResultTable';
import CustomButton from 'components/Common/ui/CustomButton';
import CustomModal from 'components/Common/CustomModal';
import { useTeacherImport } from '../hooks/useTeacherImport';
import CustomAlert from 'components/Common/ui/CustomAlert';

interface TeacherImportModalProps {
  onImportSuccess?: () => void;
}

const TeacherImportModal: React.FC<TeacherImportModalProps> = ({ onImportSuccess }) => {
  const { t } = useTranslation();
  const {
    open,
    setOpen,
    csvFile,
    setCsvFile,
    loading,
    importResult,
    handleUpload,
    handleSubmit,
    reset
  } = useTeacherImport();

  const onSubmitClick = async () => {
    await handleSubmit(t);
    onImportSuccess?.();
  };

  return (
    <>
      <CustomButton
        onClick={() => setOpen(true)}
      >
        <i className="ti ti-upload me-2" />
        {t('import_teachers')}
      </CustomButton>

      <CustomModal
        title={t('import_teachers')}
        isOpen={open}
        onClose={() => setOpen(false)}
      >
        <ImportNotice file="/assets/templates/teacher-import-model.xlsx" />
        <CustomAlert
          message={t("import_notice_format")}
          type="warning"
          showIcon={false}
        />
        <ImportUploader
          csvFile={csvFile}
          handleUpload={handleUpload}
          setCsvFile={setCsvFile}
        />

        {loading && <Spin style={{ marginTop: 16 }} />}

        {importResult && (
          <TeacherImportResultTable
            errors={importResult.errors}
            created={importResult.created}
            skipped={importResult.skipped}
          />
        )}

        <div className="d-flex justify-content-end mt-4 gap-2">
          <CustomButton
            onClick={reset}
            disabled={loading}
            variant="light"
          >
            {t('import_button_reset')}
          </CustomButton>
          <CustomButton
            onClick={onSubmitClick}
            disabled={!csvFile || loading}
          >
            {t('import_button_submit')}
          </CustomButton>
        </div>
      </CustomModal>
    </>
  );
};

export default TeacherImportModal;
